module.exports = __webpack_public_path__ + "camera.96ff98ed.png";